import { HTMLAttributes } from "react";
import "./titlewithdescription.scss";
import { ITextContentResponseModel } from "../../core/models";

interface TitleProps extends HTMLAttributes<HTMLDivElement> {
  props?: ITextContentResponseModel;
}

const TitleWithDescription = ({ props }: TitleProps) => {
  return (
    <section className="title-section">
      <h2>{props?.title}</h2>
      {props?.text && <p>{props.text}</p>}
    </section>
  );
};

export default TitleWithDescription;
